/**
 * /terms — tüm yerel ayarlarda aynı İngilizce metin (statik, güvenilir HTML).
 */
export const LEGAL_TERMS_HTML = `
<h2 class="wedy-legal__h2">Acceptance of Terms</h2>
<p>By downloading, installing, or using our Wedding App, you agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use the app.</p>

<h2 class="wedy-legal__h2">User Accounts</h2>
<p>When creating a wedding website through our app, you agree to:</p>
<ul class="wedy-legal__list">
  <li>Provide accurate and complete information</li>
  <li>Maintain the security of your account</li>
  <li>Take responsibility for all activities that occur under your account</li>
  <li>Notify us immediately of any unauthorized use</li>
</ul>

<h2 class="wedy-legal__h2">Acceptable Use</h2>
<p>You agree not to use the app to:</p>
<ul class="wedy-legal__list">
  <li>Violate any applicable laws or regulations</li>
  <li>Share inappropriate or offensive content</li>
  <li>Infringe on others' intellectual property rights</li>
  <li>Distribute malware or harmful code</li>
  <li>Spam or harass other users</li>
</ul>

<h2 class="wedy-legal__h2">Content and Copyright</h2>
<p>You retain ownership of any content you create using our app. However, you grant us a license to host and share your content through our services. You are responsible for ensuring you have the right to use any content you upload.</p>

<h2 class="wedy-legal__h2">Service Availability</h2>
<p>We strive to provide uninterrupted service but cannot guarantee the app will always be available. We reserve the right to modify or discontinue any feature at any time.</p>

<h2 class="wedy-legal__h2">Liability Limitations</h2>
<p>We provide the app "as is" without warranties of any kind. We are not liable for any damages arising from your use of the app or any content shared through it.</p>

<h2 class="wedy-legal__h2">Changes to Terms</h2>
<p>We may update these terms from time to time. Continued use of the app after changes constitutes acceptance of the new terms.</p>

<h2 class="wedy-legal__h2">Contact Information</h2>
<p>If you have any questions about these Terms of Use, please contact us at <a class="wedy-legal__link" href="mailto:wedding@mobyte.com.tr">wedding@mobyte.com.tr</a>.</p>
`.trim();
